import React, { useState, useEffect } from 'react';

const Result = () => {
    const [stage, setStage] = useState('loading'); // 'loading' → 'getSet' → 'almostThere' → 'surprise'
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        const timeouts = [];

        // Transition 1: Show "Are you ready?"
        timeouts.push(setTimeout(() => {
            setFadeOut(true); // fade out "Are you ready?"
        }, 3000)); // Message stays for 3 seconds before fading

        // Transition 2: Show "Get set"
        timeouts.push(setTimeout(() => {
            setStage('getSet');
            setFadeOut(false); // reset fadeOut for next transition
        }, 6000)); // Transition to "Get set" after 3 more seconds

        // Transition 3: Show "Almost there"
        timeouts.push(setTimeout(() => {
            setStage('almostThere');
            setFadeOut(false);
        }, 9000)); // Transition to "Almost there" after 3 more seconds

        // Transition 4: Show "Surprise!"
        timeouts.push(setTimeout(() => {
            setStage('surprise');
            setFadeOut(false);
        }, 12000)); // "Surprise!" after 3 more seconds

        // Cleanup all timeouts on component unmount
        return () => {
            timeouts.forEach(clearTimeout);
        };
    }, []);

    return (
        <div style={styles.container}>
            <h1
                style={{
                    ...styles.text,
                    opacity: fadeOut ? 0 : 1,
                    transition: 'opacity 1s ease', // 1-second fade for each transition
                }}
            >
                {stage === 'loading' ? 'Are you ready?' : ''}
                {stage === 'getSet' ? 'Get set!' : ''}
                {stage === 'almostThere' ? 'Almost there...' : ''}
            </h1>

            {stage === 'surprise' && (
                <h1
                    style={{
                        ...styles.text,
                        opacity: 1,
                        transform: 'scale(1.1)',
                        transition: 'opacity 1s ease, transform 0.5s ease', // Smooth transition for "Surprise!"
                    }}
                >
                    🎉 Surprise! 🎉
                </h1>
            )}
        </div>
    );
};

const styles = {
    container: {
        height: '100vh',
        backgroundColor: '#fef3c7',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        fontFamily: 'sans-serif',
    },
    text: {
        fontSize: '2rem',
        textAlign: 'center',
        color: '#333',
    },
};

export default Result;
